import { ComponentChildren, h, RefObject } from "preact";
import { useLayoutEffect, useRef, useState } from "preact/hooks";

import styles from "./AbsolutePositionedItemHolder.module.css";

const EDGE_PADDING = 6;

interface Props {
    baseRef: RefObject<HTMLDivElement>;
    tabIndex?: number;
    positionedParentTop: number;
    positionedParentLeft: number;
    targetTop: number;
    targetBottom: number;
    targetLeft: number;
    children: ComponentChildren;
}

export default function AbsolutePositionedItemHolder({
    baseRef,
    tabIndex,
    positionedParentTop,
    positionedParentLeft,
    targetTop,
    targetBottom,
    targetLeft,
    children
}: Props) {
    const childrenRef = useRef<HTMLDivElement>(null);
    const [top, setTop] = useState(targetBottom - positionedParentTop);
    const left = targetLeft - positionedParentLeft;

    useLayoutEffect(() => {
        const { height } = childrenRef.current!.getBoundingClientRect();
        const isOverflown = targetBottom + height + EDGE_PADDING >= window.innerHeight;

        if (isOverflown) {
            setTop(targetTop - positionedParentTop - height);
        } else {
            setTop(targetBottom - positionedParentTop);
        }
    }, [positionedParentTop, targetTop, targetBottom, children]);

    function handleRef(element: HTMLDivElement | null) {
        childrenRef.current = element!;
        baseRef.current = element!;
    }

    return (
        <div
            ref={handleRef}
            class={styles.absolutePositionedItemHolder}
            tabIndex={tabIndex}
            style={{ top, left }}>
            {children}
        </div>
    );
}

